// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-container {
  text-align: center;
  padding: 50px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.not-found-container h1 {
  font-size: 100px;
  margin-bottom: 20px;
  color: #FF6347; /* Red-Tomato color */
}

.not-found-container p {
  font-size: 18px;
  margin-bottom: 30px;
}

.home-link {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #027b9a;
  color: white;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s;
}

.home-link:hover {
  background-color: #025f7a;
}

@media (max-width: 768px) {
  .not-found-container h1 {
    font-size: 70px; /* Reduce font size on tablets */
  }
  
  .not-found-container p {
    font-size: 16px;
  }

  .home-link {
    font-size: 14px;
    padding: 8px 16px;
  }
}

@media (max-width: 480px) {
  .not-found-container h1 {
    font-size: 50px; /* Further reduce on mobile */
  }
  
  .not-found-container p {
    font-size: 14px;
  }

  .home-link {
    font-size: 12px;
    padding: 6px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NotFound.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe,EAAE,gCAAgC;EACnD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe,EAAE,6BAA6B;EAChD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".not-found-container {\n  text-align: center;\n  padding: 50px;\n  height: 80vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.not-found-container h1 {\n  font-size: 100px;\n  margin-bottom: 20px;\n  color: #FF6347; /* Red-Tomato color */\n}\n\n.not-found-container p {\n  font-size: 18px;\n  margin-bottom: 30px;\n}\n\n.home-link {\n  padding: 10px 20px;\n  font-size: 16px;\n  background-color: #027b9a;\n  color: white;\n  border-radius: 5px;\n  text-decoration: none;\n  transition: background-color 0.3s;\n}\n\n.home-link:hover {\n  background-color: #025f7a;\n}\n\n@media (max-width: 768px) {\n  .not-found-container h1 {\n    font-size: 70px; /* Reduce font size on tablets */\n  }\n  \n  .not-found-container p {\n    font-size: 16px;\n  }\n\n  .home-link {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .not-found-container h1 {\n    font-size: 50px; /* Further reduce on mobile */\n  }\n  \n  .not-found-container p {\n    font-size: 14px;\n  }\n\n  .home-link {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
